var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowDownInfo = function SvgArrowDownInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L12.7071 11.2929C12.3166 11.6834 11.6834 11.6834 11.2929 11.2929L2 2",
    stroke: "#FF6B00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
};

export default __webpack_public_path__ + "static/media/arrow-down-info.61d93c51.svg";
export { SvgArrowDownInfo as ReactComponent };